define([
	"dojo/_base/declare",
	"dojo/when",
	"csi",
	"csi/_base/underscore",
	"csi/toolbar/MultiSelectSwitchboard"
], function(declare, when, csi, _, MultiSelectSwitchboard) {

	return declare(MultiSelectSwitchboard, {
		bDelayInitialization: true,
		disableButtonAction: true,
		refreshStoreOptions: true,
		idViewProperty: "columnNodeSampleUrls",
		switchboardPath: "Child:Review/Child:ReviewSizes/Child:ReviewSizeSamples",

		canShowPlugin: function() {
			// summary: return true if more than one size
			return this.store && this.store.isLoaded() && (this.store.query().length > 1);
		},

		postCreate: function() {
			var view = this.getView();
			var self = this;
			this.inherited(arguments);
			view.watch("columnNodeUrls", function() {
				self._onChangeActive = false;
				when(self.refreshStore([]), function() {
					self._onChangeActive = true;
				});
			});
		},

		_getStoreOptions: function(/*String*/url, /*Relationship?*/r) {
			var options = this.inherited(arguments);
			var view = this.getView();
			var sampleUrls = view._getSampleUrlsFromSelectedSizes();
			var sampleUrlMap = csi.hashArray(sampleUrls, null, null);
			if (sampleUrls.length) {
				var store = this.store || this.getView().store;
				var storeId = store.idProperty;
				options.data = _.filter(options.data, function(item) {
					return sampleUrlMap[item[storeId]];
				});
			}
			return options;
		}

	});
});